(function(){

  //function to load script
  //url is the url containing the script
  //callback is the function to execute after the script is loaded
  var loadScript = function(url, callback){
 
    var script = document.createElement("script");
    script.type = "text/javascript";

    //internet explorer
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    }
    //other browsers
    else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    //append to the head tag the script
    document.getElementsByTagName("head")[0].appendChild(script);
    
  };

  //code that I want to execute
  var myCode = function($){
   //---------------    
  var isSettingsObj = JSON.parse(isSettings);
  var elem = document.querySelector(isSettingsObj.container);
    //alert(isSettingsObj.path);
  if($(isSettingsObj.path).length > 0){
    var infScroll = new InfiniteScroll( elem, {
      path: isSettingsObj.path,
      append: isSettingsObj.append,
      history: false,
      hideNav: isSettingsObj.hideNav,
      status: isSettingsObj.status
    });
  }
  //----------------
  /*  
  $("#SortBy").change(function () {
        var end = this.value;
        setTimeout(
        function() 
        {
          var isSettingsObj = JSON.parse(isSettings);
          var elem = document.querySelector(isSettingsObj.container);
          if($(isSettingsObj.path).length > 0){
            var infScroll = new InfiniteScroll( elem, {
              path: isSettingsObj.path,
              append: isSettingsObj.append,
              history: false,
              hideNav: isSettingsObj.hideNav,
              status: isSettingsObj.status
            });
          }      
          //alert(end);
        }, 5000);
    });
    */ 

  //---------------  
    
  };

  //if we already have jQuery we simply execute our function
  //if jQuery is undefined we load the script using noConflict
  if (typeof jQuery === 'undefined'){
    loadScript('//code.jquery.com/jquery-1.12.4.js', function(){
      jQuery = jQuery.noConflict(true);
      if (typeof jQuery.slick === 'undefined'){
      	loadScript('//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', function(){
       		 myCode(jQuery);	
        });
      }
    });
  } else {
    myCode(jQuery);
  }

})();